import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { Modal } from 'react-bootstrap-5';

import api from './api';
import Attachment from './attachment';
import { Button } from 'components/ui/button';

class AttachmentsModal extends React.Component {
  static propTypes = {
    attachments: PropTypes.array.isRequired,
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    show: PropTypes.bool,
    onAttachmentDeleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
  }

  deleteAttachment = (event) => {
    const attachment = this.props.attachments[parseInt(event.currentTarget.dataset.index)];
    api.deleteAttachment(this.props.path, attachment).then(() => {
      this.props.onAttachmentDeleted(attachment);
    });
  }

  render() {
    return (
      <Modal
        centered
        className="attachments-modal"
        show={this.props.show}
        onHide={this.props.onClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Attachments</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {this.props.attachments.map((attachment, i) => this.renderAttachment(attachment, i))}
        </Modal.Body>

        <Modal.Footer>
          <Button name="close-button" variant="ghost" onClick={this.props.onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderAttachment(attachment, index) {
    return (
      <div className="d-flex align-items-center py-2 justify-content-between attachment-row" key={attachment.id}>
        <Attachment attachment={attachment} />
        {this.renderDeleteControl(index)}
      </div>
    );
  }

  renderDeleteControl(index) {
    if (!this.props.readOnly) {
      return (
        <div
          className="clickable text-danger"
          data-index={index}
          name="delete-button"
          onClick={this.deleteAttachment}
        >
          <FontAwesomeIcon icon={faTrash} />
          <span className="ms-2">Delete</span>
        </div>
      );
    }
  }
}

export default AttachmentsModal;
